import { memo } from "react";
export var typedMemo = memo;
